import React, { useEffect } from 'react';
import animateScroll from 'animated-scroll-to';
import * as anime from 'animejs';

/**
 * BackToTop Component (Optimized)
 * - Converted from class to functional component
 * - Uses useEffect for scroll event listener
 * - Proper cleanup of event listener to prevent memory leaks
 */
const BackToTop = () => {
    useEffect(() => {
        const handleScroll = () => {
            const pageOffset = document.documentElement.scrollTop || document.body.scrollTop;
            if (pageOffset >= 100) {
                anime({
                    targets: '#myBtn',
                    opacity: 1
                });
            } else {
                anime({
                    targets: '#myBtn',
                    opacity: 0
                });
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup event listener on unmount
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleClick = () => {
        animateScroll(0, { minDuration: 1500 });
    };

    return (
        <button id="myBtn" onClick={handleClick} title="Go to top">
            <i className="fa fa-chevron-up"></i>
        </button>
    );
};

export default BackToTop;